import axios from "axios";
const baseUrl = require("../BaseURL")

//http://192.168.8.103:5000
// https://kadsslb.mmt-ng.com



const apiClient = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ContentType: "multipart/form-data",
        
    },
})






export const Postrequest = async (url,data,accessToken) => {

    try {
        const response = await apiClient.post(url, data,
            {
            
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    
                }
            })
        
        return response.data
    } catch (error) {
         console.log("Post Request Error:",error.response?.data || error.message)
        return {success:false,error: error.response?.data || error.message}
    }

}

export const Multipartrequest = async (url,data,accessToken) => {

    try {
        const response = await apiClient.put(url, data,
            {
                headers: {
                Authorization: `Bearer ${accessToken}`,
                Accept : 'application/json',
                ContentType: "multipart/form-data",
                }
            })
        
        return response.data
    } catch (error) {
         console.log("Post Request Error:",error.response?.data || error.message)
        return {success:false,error: error.response?.data || error.message}
    }

}


export const Getrequest = async (url,accessToken) => {


    try {
        const response = await apiClient.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            }
        })
        return response.data
    } catch (error) {
        console.log("Get Request Error:",error.response?.data || error.message)
        return {success:false,error: error.response?.data || error.message}
    }

}


export const Putrequest = async (url,data,accessToken) => {

    try {
        const response = await apiClient.put(url,data,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            })
        return response.data
    } catch (error) {
        console.log("Put Request Error:",error.response?.data || error.message)
        return {success:false,error: error.response?.data || error.message}
    }

}



export const Deleterequest = async (url,accessToken) => {

    try {
        const response = await apiClient.delete(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            }
        })
        return response.data
    } catch (error) {
        console.log("Delete Request Error:",error.response?.data || error.message)
        return {success:false,error: error.response?.data || error.message}
    }

}
